var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_vm._ssrNode("Please implement vendor-specific UserBillingAddress component in the 'components' directory")])}
var staticRenderFns = []

export { render, staticRenderFns }